import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getMentionInMediaByApplicationId(applicationId: string) {
  return await prisma.applicantMentionInMedia.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
